// frontend/src/main.jsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

class RootBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }
  static getDerivedStateFromError(error) {
    return { error }
  }
  componentDidCatch(error, info) {
    // Surface the error so it’s visible in production builds too
    console.error('App crashed:', error, info)
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6">
          <div className="max-w-md w-full text-center">
            <h1 className="text-6xl font-bold text-slate-600 mb-4">Oops</h1>
            <p className="text-xl font-semibold text-slate-200 mb-2">Something went wrong</p>
            <p className="text-slate-400 mb-8">An unexpected error occurred. Try refreshing the page.</p>
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center px-6 py-3 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white font-semibold transition-colors"
            >
              Refresh page
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

// Extra safety: log unhandled errors
window.addEventListener('error', (e) => console.error('Unhandled error', e.error || e.message))
window.addEventListener('unhandledrejection', (e) => console.error('Unhandled rejection', e.reason))

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RootBoundary>
      <App />
    </RootBoundary>
  </React.StrictMode>
)
